module.exports = __webpack_public_path__ + "img/banner16_9.png";